import { MoneyBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { toPositiveNumber } from './functions/toPositiveNumber';

export const BrokerAdditionalField = () => {
    const value = useStandardLoanStore((state) => state.loan.brokerAdditional);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <MoneyBox
            id='loanBrokerAdditional'
            value={value}
            onChange={(amount) => updateLoan({ brokerAdditional: toPositiveNumber(amount) })}
            label='Broker Addl.'
            displayChange={true}
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
